import { createSelector } from "reselect";
import { selectors as requestSelectors } from "redux-request-state";

const lossReasonsBase = state => state.lossReasons;
export const isLoadingLossReasons = requestSelectors.isLoading( lossReasonsBase );
export const getLossReasons = createSelector( lossReasonsBase, lossReasons => lossReasons.data );